import apiClient from './client';

export interface WebhookSubscription {
  id: string;
  tenant_id: string | null;
  name: string;
  url: string;
  events: string[];
  is_enabled: boolean;
  has_secret: boolean;
  created_by: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface WebhookDelivery {
  id: string;
  subscription_id: string;
  event_type: string;
  payload: Record<string, unknown> | null;
  status: string;
  attempts: number;
  response_status: number | null;
  last_error: string | null;
  next_retry_at: string | null;
  created_at: string | null;
  delivered_at: string | null;
}

/** 后端支持的事件类型白名单（与 webhook_service.SUPPORTED_EVENTS 对齐）。 */
export const WEBHOOK_EVENTS = ['runtime.state_changed', 'deployment.finished', 'escalation.required'] as const;

export const WEBHOOK_EVENT_LABELS: Record<string, string> = {
  'runtime.state_changed': '运行时状态变更',
  'deployment.finished': '部署终态',
  'escalation.required': '升级人工',
};

export interface WebhookCreateInput {
  name: string;
  url: string;
  secret: string;
  events: string[];
}

export interface WebhookUpdateInput {
  name?: string;
  url?: string;
  secret?: string;
  events?: string[];
  is_enabled?: boolean;
}

export async function listWebhooks(): Promise<WebhookSubscription[]> {
  const res = await apiClient.get('/webhooks');
  return res.data;
}

export async function createWebhook(data: WebhookCreateInput): Promise<WebhookSubscription> {
  const res = await apiClient.post('/webhooks', data);
  return res.data;
}

export async function updateWebhook(id: string, data: WebhookUpdateInput): Promise<WebhookSubscription> {
  const res = await apiClient.put(`/webhooks/${id}`, data);
  return res.data;
}

export async function deleteWebhook(id: string): Promise<void> {
  await apiClient.delete(`/webhooks/${id}`);
}

export async function listWebhookDeliveries(id: string, status?: string, limit = 50): Promise<WebhookDelivery[]> {
  const res = await apiClient.get(`/webhooks/${id}/deliveries`, { params: { status, limit } });
  return res.data;
}

export async function testWebhook(id: string): Promise<WebhookDelivery> {
  const res = await apiClient.post(`/webhooks/${id}/test`);
  return res.data;
}
